import { baseAgencyParameter } from '@app/pcs/data/agency-parameter.fragment';
import { DictionaryEntity } from '@app/pcs/models';
import { PairAgency, pairAgency } from '@dossier/models/pair-agency';
import { childImParameter } from '@dossier/models/train-parameters';
import { gql } from 'apollo-angular';

interface PaPmData {
  processInitiator?: boolean;
  affectedByProcess?: boolean;
}

export interface RuImPair {
  id?: number;
  dossierId?: number;
  applicantAgency?: PairAgency;
  imAgency?: PairAgency;
  involvedCossAgencies?: PairAgency[];
  permanentImAcceptance?: boolean;
  processTypeId?: DictionaryEntity;
  dossierStatusId?: DictionaryEntity;
  paPmData?: PaPmData;
  dossierLevelParameters?: any[];
  sortOrder?: number;
}

export enum RuImPairPropertyMap {
  ApplicantProgressStatus = 'applicantProgressStatusId',
  ImProgressStatus = 'imProgressStatusId',
  CossProgressStatus = 'cossProgressStatusId',
  ApplicantLeadingAgency = 'ffEvuId',
  ImLeadingAgency = 'ffKmId',
  PairApplicantId = 'applicantId',
  PermanentImAcceptance = 'permanentImAcceptance',
  AffectedByProcess = 'affectedByProcess'
}

export const ruImPairDetailed = gql`
  fragment ruImPairDetailed on DossierRuImPair {
    id
    persistedId
    dossierId
    sortOrder
    applicantAgency {
      ...pairAgency
    }
    imAgency {
      ...pairAgency
    }
    involvedCossAgencies {
      ...pairAgency
    }
    permanentImAcceptance
    processTypeId {
      id
      description
    }
    dossierStatusId {
      id
      description
    }
    dossierLevelParameters {
      id
      agencyParameter {
        ...baseAgencyParameter
      }
      mandatory
      missingValue
      children {
        ...childImParameter
        children {
          ...childImParameter
          children {
            ...childImParameter
          }
        }
      }
      value
      values
    }
    paPmData {
      processInitiator
      affectedByProcess
    }
  }
  ${pairAgency}
  ${baseAgencyParameter}
  ${childImParameter}
`;

export const ruImPairAgencies = gql`
  fragment ruImPairAgencies on DossierRuImPair {
    id
    persistedId
    dossierId
    sortOrder
    applicantAgency {
      ...pairAgency
    }
    imAgency {
      ...pairAgency
    }
    involvedCossAgencies {
      ...pairAgency
    }
    permanentImAcceptance
    processTypeId {
      id
      description
    }
    dossierStatusId {
      id
      description
    }
  }
  ${pairAgency}
`;

export const ruImPairWithPaPmData = gql`
  fragment ruImPairWithPaPmData on DossierRuImPair {
    id
    applicantAgency {
      ...pairAgency
    }
    imAgency {
      ...pairAgency
    }
    paPmData {
      processInitiator
      affectedByProcess
    }
  }
  ${pairAgency}
`;
